
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import gameApplication from "../../game/game-app";

export default defineComponent({
  name: "ConcedeGameModal",

  methods: {
    onYes(): void {
      gameApplication.sendLeaveGameMessage();
      
      this.$emit('close');
    },

    onNo(): void {     
      this.$emit('close');
    },
  },

  components: { Modal },
});
